/* istanbul ignore file */
import gql from 'graphql-tag';

const GET_CONTENT = gql`
  query getContent($payload: ContentRequestInput!) {
    getContent(payload: $payload) {
      source
      entries {
        type
        attributes {
          key
          value
        }
        entries {
          type
          attributes {
            key
            value
          }
          entries {
            type
            attributes {
              key
              value
            }
            entries {
              type
              attributes {
                key
                value
              }
              entries {
                type
                attributes {
                  key
                  value
                }
                entries {
                  type
                  attributes {
                    key
                    value
                  }
                  entries {
                    type
                    attributes {
                      key
                      value
                    }
                    entries {
                      type
                      attributes {
                        key
                        value
                      }
                      entries {
                        type
                        attributes {
                          key
                          value
                        }
                        entries {
                          type
                          attributes {
                            key
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_CONTENT;
